export type FieldErrors<TFields extends string> = Partial<Record<TFields, string>>;

export const PASSWORD_MIN_LENGTH = 8;

// Базовая проверка
export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email.trim());

export const normalize = (value: string): string => value.trim();

export const isNonEmpty = (value: string): boolean => normalize(value).length > 0;

export const isPasswordLongEnough = (password: string): boolean =>
  password.length >= PASSWORD_MIN_LENGTH;

// хотя бы одна буква
export const hasLetter = (value: string): boolean => /[A-Za-zА-Яа-яЁё]/.test(value);

// хотя бы одна цифра
export const hasDigit = (value: string): boolean => /\d/.test(value);

export const isPasswordStrongEnough = (password: string): boolean =>
  hasLetter(password) && hasDigit(password);

/**
 * Пароль обязателен (регистрация / создание пользователя)
 */
export const validateRequiredPassword = (password: string): string | null => {
  if (!password) return "required";
  if (!isPasswordLongEnough(password)) return "too_short";
  if (!isPasswordStrongEnough(password)) return "weak";
  return null;
};
